// extracted by mini-css-extract-plugin
export default {"container":"WhatsApp_container__BSXOy","link":"WhatsApp_link__UfoE2","img":"WhatsApp_img__4dm0a"};